import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Users, FileImage, Gift, TrendingUp, ArrowRight } from 'lucide-react';

const CARDS = [
  {
    to: '/backoffice/accounts',
    icon: <Building2 size={24} />,
    iconBg: '#dcfce7',
    iconColor: '#16a34a',
    title: 'Accounts & Users',
    desc: 'Company list with admin/employee counts, invite funnel stats, and last-login tracking.',
  },
  {
    to: '/backoffice/engagement',
    icon: <Users size={24} />,
    iconBg: '#dbeafe',
    iconColor: '#1d4ed8',
    title: 'Engagement',
    desc: 'Monthly active users and Moments activity, filterable by date range and account.',
  },
  {
    to: '/backoffice/content',
    icon: <FileImage size={24} />,
    iconBg: '#fef9c3',
    iconColor: '#a16207',
    title: 'Content Pipeline',
    desc: 'Submission volume and moderation stats — approved, rejected, and pending content.',
  },
  {
    to: '/backoffice/rewards',
    icon: <Gift size={24} />,
    iconBg: '#fce7f3',
    iconColor: '#be185d',
    title: 'Rewards & Fulfillment',
    desc: 'Claimed, fulfilled, and pending reward requests with points breakdown per account.',
  },
  {
    to: '/backoffice/trends',
    icon: <TrendingUp size={24} />,
    iconBg: '#ede9fe',
    iconColor: '#7c3aed',
    title: 'Suggested Trends',
    desc: 'Create and manage global or company-specific content trends to inspire employee submissions.',
  },
];

export default function BackOfficeDashboardPage() {
  return (
    <>
      <div className="bo-page-header">
        <h1 className="bo-page-title">Back Office</h1>
        <p className="bo-page-subtitle">
          Internal dashboard — account health, engagement, content, and rewards across all companies.
        </p>
      </div>

      <div className="bo-nav-card-grid">
        {CARDS.map((card) => (
          <Link key={card.to} to={card.to} className="bo-nav-card">
            <div
              className="bo-nav-card-icon"
              style={{ background: card.iconBg, color: card.iconColor }}
            >
              {card.icon}
            </div>
            <h2 className="bo-nav-card-title">{card.title}</h2>
            <p className="bo-nav-card-desc">{card.desc}</p>
            <span className="bo-nav-card-arrow">
              View section <ArrowRight size={14} />
            </span>
          </Link>
        ))}
      </div>
    </>
  );
}
